<template>
  <TaskBoard
    :columns="getGroupedTasksByStatus"
    :modals="modals"
    :dragged-task-id="draggedTaskId"
    :focus-task="getFocusTask"
    :show-bulk-actions="showBulkActions"
    :selected-task-ids="selectedTaskIds"
    :animated-task-id="animatedTaskId"
    v-loading="(isLoading && !loadingFocusTask) || archiveLoading"
    @handle-drag-and-drop="handleDragAndDrop"
    @handle-update-assignee="handleUpdateAssignee"
    @handle-update-status="handleUpdateStatus"
    @handle-is-archive="handleIsArchive"
    @handle-show-bulk-actions="showBulkActions = true"
    @add-upvote="addUpvote"
    @remove-upvote="removeUpvote"
    @open-focus-task="handleFocusTaskOpening"
    @close-assignee-modal="modals.assignee = false"
    @close-focus-modal="handleFocusTaskClosing"
    @update-selected-tasks="$emit('update-selected-tasks', $event)"
    @handle-new-comment="handleNewComment"
    @delete-comment="handleDeleteComment"
    @empty-filters="$emit('empty-filters')"
    @update-rating="handleUpdateRating"
    @delete-rating="handleDeleteRating"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import TaskBoard from './TaskBoard.vue';

export default {
  name: 'task-board-wrapper',
  components: {
    TaskBoard,
  },
  props: {
    selectedTaskIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: null,
      dragAndDropHandlers: {
        added: this.handleAdd,
        removed: this.handleRemove,
      },
      modals: {
        assignee: false,
        focus: false,
      },
      draggedTaskId: null,
      showBulkActions: false,
      lastColumnId: null,
      animatedTaskId: null,
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      this.isLoading = true;
      // This needs to be refactored hard
      await Promise.all([
        this.getCompanyTaskStatus(),
        this.getCompanyTasks(),
        this.getAssignableUsers(['EDIT_KNOWLEDGE_BASE']),
        this.getCompanyUserLabelCategories(),
        this.getCustomRoles(),
        this.getKnowledges(),
        this.getContributors(),
      ]);
      this.lastColumnId =
        this.getOrderedCompanyTaskStatus[
          this.getOrderedCompanyTaskStatus.length - 1
        ].id;

      this.isLoading = false;
    },
    handleDragAndDrop(e) {
      const type = Object.keys(e.$event)[0];
      const eventHandler = this.dragAndDropHandlers[type];

      eventHandler(e);
    },
    handleAdd(e) {
      const {
        $event: {
          added: { element },
        },
      } = e;
      const { companyTaskStatusId } = e;
      if (!element.assignee) {
        this.draggedTaskId = element.id;
        this.modals.assignee = true;
      }
      this.addTaskToColumn({
        taskId: element.id,
        newCompanyTaskStatusId: companyTaskStatusId,
      });
      if (companyTaskStatusId === this.lastColumnId)
        this.animatedTaskId = element.id;
      else this.animatedTaskId = null;
    },
    handleRemove(e) {
      const {
        $event: {
          removed: { element },
        },
      } = e;
      const { companyTaskStatusId } = e;
      this.removeTaskFromColumn({
        taskId: element.id,
        oldCompanyTaskStatusId: companyTaskStatusId,
      });
    },
    handleUpdateAssignee(e) {
      const { assignee } = e;
      let { taskId } = e;
      if (!taskId) {
        taskId = this.draggedTaskId;
      }
      this.setAssignee({ taskId, assignee });

      this.modals.assignee = false;
    },
    handleUpdateStatus(e) {
      const { $event, taskId, oldStatusId } = e;
      this.setCompanyTaskStatus({
        taskId,
        newCompanyTaskStatusId: $event,
        oldCompanyTaskStatusId: oldStatusId,
      });
    },
    handleFocusTaskOpening($event) {
      const { taskId } = $event;
      this.$router.replace({ query: { modalTaskId: taskId } });
    },
    handleFocusTaskClosing() {
      this.$router.replace({ query: {} });
      this.modals.focus = false;
    },
    handleIsArchive(e) {
      const { taskId, isArchive } = e;
      this.bulkSetIsArchive({ ids: [taskId], isArchive });
      this.modals.focus = false;
      this.$emit('update-selected-tasks', []);
    },
    addUpvote($event) {
      const { taskId } = $event;
      this.upvoteTask({ taskId });
    },
    removeUpvote($event) {
      const { taskId } = $event;
      this.removeUpvoteTask({ taskId });
    },
    async focusOnTask(routeQuery) {
      const { modalTaskId } = routeQuery;
      if (modalTaskId) {
        this.modals.focus = true;
        await this.setFocusTask({ taskId: modalTaskId });
      }
    },
    handleNewComment($event) {
      this.newTaskComment($event);
    },
    handleDeleteComment($event) {
      this.deleteTaskComment($event);
    },
    handleUpdateRating($event) {
      this.setTaskRating($event);
    },
    handleDeleteRating($event) {
      this.deleteTaskRating($event);
    },
    ...mapActions('taskModule', [
      'getCompanyTaskStatus',
      'getCompanyTasks',
      'addTaskToColumn',
      'removeTaskFromColumn',
      'getAssignableUsers',
      'setFocusTask',
      'setCompanyTaskStatus',
      'setAssignee',
      'bulkSetIsArchive',
      'upvoteTask',
      'removeUpvoteTask',
      'newTaskComment',
      'deleteTaskComment',
      'setTaskRating',
      'deleteTaskRating',
    ]),
    ...mapActions('adminModule', [
      'getCompanyUserLabelCategories',
      'getCustomRoles',
      'getContributors',
    ]),
    ...mapActions('webKnowledgeModule', ['getKnowledges']),
  },
  computed: {
    ...mapGetters('taskModule', [
      'getGroupedTasksByStatus',
      'getFocusTask',
      'getOrderedCompanyTaskStatus',
      'loadingFocusTask',
      'archiveLoading',
    ]),
  },
  watch: {
    $route: {
      async handler(newVal) {
        await this.focusOnTask(newVal.query);
      },
      immediate: true,
    },
  },
};
</script>

<style></style>
